import React from 'react'
import {MainUrlTypes} from '../../types'
import {useTranslation} from '../../util/i18n'
import {getUrlByKey} from '../../util/nav'
import {style} from '../../util/style'
import {CardSwitchType} from '../layout/cards/CardSwitch'
import {Overview} from '../layout/Overview'
import {Block} from './Blocks'

const styles = style('newsblock')

export type NewsBlockType = {
	main_pages?: Array<MainUrlTypes>
	title?: string
	news: Array<CardSwitchType>
}

export const NewsBlock: React.FC<NewsBlockType & {container?: boolean}> = ({
	container,
	main_pages,
	title,
	news
}) => {
	const t = useTranslation()
	const newsLoadMoreLink = getUrlByKey(main_pages, 'news')
	if (!news || news.length === 0) return null

	return (
		<Block className={styles()} container={container}>
			<Overview
				title={title || t.news.title}
				items={news}
				maxBeforeLoadMore={6}
				disableLoadmoreByLink={newsLoadMoreLink}
			/>
		</Block>
	)
}
